/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in 
 *                 part without express written permission of Honeywell Inc. 
 *                 is prohibited.
 *
 * Name          :  InlineNotificationComponent.tsx
 * 
 * Project Title :  Checkout
 *  
 * Description	: 
 * 
 * 
 * Company       : Honeywell Technology Solutions , Hyderabad
 * 
 * @Author       : 
 * 
 * @Date			: Dec 30, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : H224423
 * On            : Dec 30, 2019
 * Description   : Added Modification history and UT test cases.
 *
 * By            : H224423
 * On            : Apr 01, 2020
 * Description   : ASDS-2190 - API error handling. Updated icon. 
*******************************************************************************/
import * as React from 'react';
import { Modal, Button, Icon } from '@scuf/common';
import '@scuf/common/honeywell/theme.css';
import './inlineNotificationComponent.css';

interface InoticeRequestSuccessfulState {
    open: any;
    hasClickOut: any;
}

interface InoticeRequestSuccessfulProps {
    stateOptions?: any;
    notificationContent?: string;
    notificationType: string;
    notificationReturnCallBack: Function;
}

class NoticeRequestSuccessful extends React.Component<InoticeRequestSuccessfulProps, InoticeRequestSuccessfulState> {

    constructor(props: InoticeRequestSuccessfulProps) {
        super(props);
        this.closeModal = this.closeModal.bind(this);
        this.state = {
            open: true,
            hasClickOut: true,
        };
    }

    render() {
        return (
            <React.Fragment>

                {this.renderModal()}

            </React.Fragment>
        );
    }

    closeModal() {
        this.setState({
            open: false,
        },            () => {
            this.props.notificationReturnCallBack();
        });
    }

    renderModal() {
        return (
            <Modal closeIcon={true} onClose={this.closeModal} size="large" open={this.state.open}
                closeOnDimmerClick={this.state.hasClickOut} closeOnDocumentClick={this.state.hasClickOut} className="selectAccountModal">
                <Modal.Header>
                    Notice
                </Modal.Header>

                <Modal.Content>
                    {this.props.notificationType === 'success' && <React.Fragment><Icon name="check" root="common" size="medium" color="#7EB338" /><b>&nbsp;&nbsp;&nbsp;New address creation request is successful.</b></React.Fragment>}
                    {this.props.notificationType === 'failure' && <React.Fragment><Icon name="badge-stop" root="common" size="medium" color="#F15A4F" /><b>&nbsp;&nbsp;&nbsp;New address creation request is Failed.</b></React.Fragment>}
                    <br /><br />
                    {this.props.notificationContent}
                </Modal.Content>

                <Modal.Footer>
                    <div>
                        <Button type="primary" size="medium" content="OK" onClick={this.closeModal} />
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default NoticeRequestSuccessful;